module.exports = __webpack_public_path__ + "img/智驹首页轮播图Z61---4.a3f17df5.jpg";